/**
 * SSO redirect helpers — extracted from the three duplicated call sites
 * cited in AAA-001 §5:
 *   - apps/pod/pod-v0.html:1677 (apiFetch + ssoRedirect)
 *   - apps/salesroom/salesroom-workspace.js:1242 (401 → oauth2/start)
 *   - apps/comitia/comitia.html:319-328 (oauth2/start?rd=)
 */

/** Canonical oauth2-proxy start URL used in production today. */
export const DEFAULT_SSO_START_URL =
  "https://sso.axisnode.site/oauth2/start" as const;

/**
 * Build the SSO start URL with `rd` = the URL to return to after login.
 * Matches the three existing apps: `oauth2/start?rd=` + encodeURIComponent(...).
 */
export function buildSsoRedirectUrl(
  returnUrl: string,
  ssoStartUrl: string = DEFAULT_SSO_START_URL,
): string {
  return `${ssoStartUrl}?rd=${encodeURIComponent(returnUrl)}`;
}

/** Hosts where POD today skips the SSO round-trip and surfaces the 401. */
export function isLocalDevHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]"
  );
}
